import _ from 'lodash'
import QueryParam from 'common/src/vtj/QueryParam.enum'

export const getLoginStatus = (queryParameters = {}) => ({
  failed: '' + queryParameters[QueryParam.SUOMIFI_AUTH_FAILURE] === 'true',
  canceled: '' + queryParameters[QueryParam.SUOMIFI_AUTH_CANCELED] === 'true',
})

export const getLoginErrorMessage = (queryParameters = {}) => {
  const { canceled, failed } = getLoginStatus(queryParameters)
  if (canceled) {
    return 'authenticationCanceled'
  }
  if (failed) {
    return 'authenticationFailure'
  }
  return ''
}

export const addQueryParameters = (url, params = {}) => {
  const fileteredParams = Object.keys(params).filter(
    (k) => !_.isNil(params[k]) && params[k] !== ''
  )
  return _.isEmpty(fileteredParams)
    ? url
    : `${url}?${fileteredParams.map((k) => `${k}=${params[k]}`).join('&')}`
}
